import React from "react";
import { Datagrid, TextField } from "react-admin";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import PbhNotesFiled from "../../../../../Components/ReferenceFields/Notes/PbhNotesFiled";
import { PbhRequestStatus } from "../../../../../Enums/PbhRequestStatus";
import DataGridActionsButtons from "./DataGridActionsButtons";
import RefNoField from "../../../../../../src/Components/ReferenceFields/RefNoField/RefNoField";
import CopyableTableWrapper from "../../../../../../src/Components/CopyableTableWrapper";
export const WaitingPoolScopeDataGrid = props => {
  const onEdit = (id, basePat, record) => {
    if (basePat == "/pbhrequestremarks/pbhrequestorders/") {
      props?.onCreateRemarks?.(record);
    } else {
      const win: any = window.open(`#/pbhrequestorders/${id}`, "_blank");
      win.focus();
    }
  };
  return (
    <CopyableTableWrapper>
      <Datagrid optimized {...props} classes={{ table: props.classes.datagrid }} hasBulkActions={false}>
        <DataGridActionsButtons
          label={"Actions"}
          onEdit={onEdit}
          tabValue={PbhRequestStatus.WaitingPoolScope}
          reloadTabs={props.reloadTabs}
        />
        <RefNoField label="REF NO" />
        <TextField source="customerName" label="CUSTOMER" sortable={false} />
        <TextField source="customerPo" label="CUSTOMER PO" />
        <TextField source="requirementCategoryText" label="REQUIREMENT CATEGORY" />
        <TextField source="pn" label="PN" />
        <TextField source="airportCode" label="DESTINATION" />
        <TextField source="acRegistration" label="AC" />
        <CustomDateField source="createdDate" label="REQUEST DATE" showTime />
        <CustomDateField source="requestedDeliveryDate" label="REQUESTED DELIVERY DATE" showTime locales="en-GB" />
        <PbhNotesFiled label="PBH NOTE" />
      </Datagrid>
    </CopyableTableWrapper>
  );
};

export default WaitingPoolScopeDataGrid;
